import { Firestore, Auth } from "../../config/firebase";
import * as firebase from "firebase";
class Collection {
  constructor(user) {
    this.count = 0;
  }

  checkCollectionbyUser(postID) {
    return Firestore.collection("users")
      .doc(Auth.currentUser.uid)
      .get()
      .then(doc => {
        if (typeof doc.data().collections != "undefined") {
          return doc.data().collections.findIndex(res => res.post_id == postID);
        }

        return -1;
      });
  }

  async create(postID) {
    this.CreateCollections(postID);
  }

  CreateCollections(postID) {
    if (Auth.currentUser && Auth.currentUser.uid) {
      Firestore.collection("users")
        .doc(Auth.currentUser.uid)
        .update({
          collections: firebase.firestore.FieldValue.arrayUnion(postID)
        });
    }
  }
}

export default new Collection();
